import { render, staticRenderFns } from "./CheckWarning.vue?vue&type=template&id=ff15413a&scoped=true&"
import script from "./CheckWarning.vue?vue&type=script&lang=js&"
export * from "./CheckWarning.vue?vue&type=script&lang=js&"
import style0 from "./CheckWarning.vue?vue&type=style&index=0&id=ff15413a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff15413a",
  null
  
)

export default component.exports